(() => {
  if (customElements.get('homepage-brand-scroll')) return;
  customElements.define('homepage-brand-scroll', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul');
      this.buttons = [...this.querySelectorAll('button')];
      if (!this.list || this.buttons.length !== 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const mobile = matchMedia('(max-width: 749px)').matches;
        const max = this.list.scrollWidth - this.list.clientWidth;
        const scrollable = mobile && max > 1;
        this.toggleAttribute('data-scrollable', scrollable);
        this.buttons.forEach((button, index) => {
          button.hidden = !scrollable;
          button.disabled = index === 0 ? this.list.scrollLeft <= 1 : this.list.scrollLeft >= max - 1;
        });
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.list.scrollBy({
          left: Number(button.dataset.direction) * this.list.clientWidth * .8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, options));
      this.list.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.list);
      this.update();
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
})();
